var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "rd_box register" }, [
      _c("div", { staticClass: "container register" }, [
        _c("div", { staticClass: "title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.MY.USER.INFO")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "user_info" }, [
            _c("table", { staticClass: "view_table noLine" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.EUR.YOUR.COUNTRY")) +
                        " / " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.LANGUAGE"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm.countryNm) + " / " + _vm._s(_vm.langNm))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.GLOBAL.ID")) +
                        "(" +
                        _vm._s(_vm.$t("FIELD.GLOBAL.EMAIL")) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.email))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.PROFILE.COMPANY.NAME")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.companyNm,
                                expression: "companyNm"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            ref: "compNm",
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "50" },
                            domProps: { value: _vm.companyNm },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.companyNm = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.companyNm))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.NUMBER")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.companyNo,
                                expression: "companyNo"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            ref: "compNo",
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "30" },
                            domProps: { value: _vm.companyNo },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.companyNo = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.companyNo))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.COMP.ADDR")))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address,
                                expression: "address"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "90" },
                            domProps: { value: _vm.address },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.address = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.address))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.POSTAL.CODE")))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.zipCd,
                                expression: "zipCd"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "10" },
                            domProps: { value: _vm.zipCd },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.zipCd = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.zipCd))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.WEBSITE.ADDRESS")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.homeUrl,
                                expression: "homeUrl"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "40" },
                            domProps: { value: _vm.homeUrl },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.homeUrl = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.homeUrl))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.NAME")))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contactFrstNm,
                                expression: "contactFrstNm"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "20" },
                            domProps: { value: _vm.contactFrstNm },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.contactFrstNm = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.contactFrstNm))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.LAST.NAME")))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contactLastNm,
                                expression: "contactLastNm"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "20" },
                            domProps: { value: _vm.contactLastNm },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.contactLastNm = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.contactLastNm))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.CONTACT.PHONE.NUMBER")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.mode == "edit"
                      ? _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contactPhoneNo,
                                expression: "contactPhoneNo"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: { type: "text", maxlength: "20" },
                            domProps: { value: _vm.contactPhoneNo },
                            on: {
                              keyup: function($event) {
                                return _vm.onlyNumber2($event)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.contactPhoneNo = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode == "view"
                      ? _c("span", [_vm._v(_vm._s(_vm.contactPhoneNo))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.countryCd == "FR" || _vm.apeCodes
                  ? _c("tr", [
                      _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.APE.CODES")))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm.mode == "edit"
                          ? _c("span", { staticClass: "clearable" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.apeCodes,
                                    expression: "apeCodes"
                                  },
                                  { name: "clearable", rawName: "v-clearable" }
                                ],
                                staticClass: "text_input w100",
                                attrs: { type: "text", maxlength: "99" },
                                domProps: { value: _vm.apeCodes },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.apeCodes = $event.target.value
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode == "view"
                          ? _c("span", [_vm._v(_vm._s(_vm.apeCodes))])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.INSURANCE.POLICY")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      { staticClass: "one-input-container modify file-input" },
                      [
                        _vm.mode == "edit"
                          ? _c("div", { staticClass: "upload-btn_wrap" }, [
                              _c(
                                "button",
                                {
                                  attrs: { type: "button", title: "Find file" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("BUTTON.EUR.BROWSER")))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "input_file",
                                attrs: {
                                  type: "file",
                                  id: "file1",
                                  title: "Find file"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.fileUpload($event, 1)
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode == "edit"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.attachFile1Name,
                                  expression: "attachFile1Name"
                                }
                              ],
                              staticClass: "upload_text",
                              attrs: {
                                type: "text",
                                readonly: "readonly",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.attachFile1Name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.attachFile1Name = $event.target.value
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode == "view" && _vm.attachFile1Name
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "JavaScript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadFile("1")
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.attachFile1Name) +
                                        " (" +
                                        _vm._s(
                                          _vm._f("numberFormat")(_vm.fileMb1)
                                        ) +
                                        "KB)"
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.FILE")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      { staticClass: "one-input-container modify file-input" },
                      [
                        _vm.mode == "edit"
                          ? _c("div", { staticClass: "upload-btn_wrap" }, [
                              _c(
                                "button",
                                {
                                  attrs: { type: "button", title: "Find file" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("BUTTON.EUR.BROWSER")))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "input_file",
                                attrs: {
                                  type: "file",
                                  id: "file2",
                                  title: "Find file"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.fileUpload($event, 2)
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode == "edit"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.attachFile2Name,
                                  expression: "attachFile2Name"
                                }
                              ],
                              staticClass: "upload_text",
                              attrs: {
                                type: "text",
                                readonly: "readonly",
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.attachFile2Name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.attachFile2Name = $event.target.value
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode == "view" && _vm.attachFile2Name
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "JavaScript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadFile("2")
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.attachFile2Name) +
                                        " (" +
                                        _vm._s(
                                          _vm._f("numberFormat")(_vm.fileMb2)
                                        ) +
                                        "KB)"
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "one-btn-wrap" }, [
              _c(
                "button",
                { staticClass: "bt-type-b", on: { click: _vm.goBackList } },
                [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "bt-type-b next",
                  on: { click: _vm.saveMyInfo }
                },
                [_vm._v(_vm._s(_vm.btnText))]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "270px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0170ba25", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0170ba25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/EditMyUserInfo.vue
// module id = rvOI
// module chunks = 0